import * as Actions from '../../actions';

const initialState={
    data: [],
    selected: {
        data: null,
        isLoading: false,
        error: false,
    },
    isLoading: false,
    error: false
};

const getExtrasReducer=(state=initialState,action) => {
    switch(action.type) {

        case Actions.ADD_EXTRA: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.ADD_EXTRA_SUCCESS: {
            return {
                ...state,
                data: [...state.data,action.payload],
                isLoading: false,
                error: false
            };
        }
        case Actions.ADD_EXTRA_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }

        case Actions.CHANGE_EXTRAS_VISIBILITY: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.CHANGE_EXTRAS_VISIBILITY_SUCCESS: {
            action.payload.ids.forEach(id => {
                let index=state.data.findIndex(p => p._id===id)
                if(index>-1)
                    state.data[index].visibility=action.payload.visibility
            })
            return {
                ...state,
                isLoading: false,
                error: false
            };
        }
        case Actions.CHANGE_EXTRAS_VISIBILITY_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }

        case Actions.DELETE_EXTRA: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.DELETE_EXTRA_SUCCESS: {
            return {
                ...state,
                data: state.data.filter(p => p._id!==action.payload),
                isLoading: false,
                error: false
            };
        }
        case Actions.DELETE_EXTRA_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }

        case Actions.DELETE_EXTRAS: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.DELETE_EXTRAS_SUCCESS: {
            return {
                ...state,
                data: state.data.filter(o => !action.payload.includes(o._id)),
                isLoading: false,
                error: false
            };
        }
        case Actions.DELETE_EXTRAS_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }

        case Actions.GET_EXTRA: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.GET_EXTRA_SUCCESS: {
            return {
                ...state,
                selected: {
                    data: action.payload,
                    isLoading: false,
                    error: false
                },
                isLoading: false,
                error: false
            };
        }
        case Actions.GET_EXTRA_ERROR: {
            return {
                ...state,
                selected: {
                    data: null,
                    isLoading: false,
                    error: action.payload
                },
                isLoading: false,
                error: action.payload
            };
        }

        case Actions.GET_EXTRAS: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.GET_EXTRAS_SUCCESS: {
            return {
                ...state,
                data: action.payload,
                isLoading: false,
                error: false
            };
        }
        case Actions.GET_EXTRAS_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }


        case Actions.UPDATE_EXTRA: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.UPDATE_EXTRA_SUCCESS: {

            const index=state.data.findIndex(p => p._id===action.payload._id)
            state.data[index]=action.payload
            return {
                ...state,
                isLoading: false,
                error: false
            };
        }
        case Actions.UPDATE_EXTRA_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }


        case Actions.UPDATE_PRODUCT_LISTS: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.UPDATE_PRODUCT_LISTS_SUCCESS: {
            if(action.payload.params.type==='extras') {
                const index=state.data.findIndex(p => p._id===action.payload.params._id)
                if(action.payload.params.action==='add')
                    state.data[index].parentProducts.push({_id: action.payload.params.productId})
                else
                    state.data[index].parentProducts=state.data[index].parentProducts.filter(v => v._id!==action.payload.params.productId)

                return {
                    ...state,
                    isLoading: false,
                    error: false
                }
            }
        }
        case Actions.UPDATE_PRODUCT_LISTS_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }
            
        case Actions.LOGOUT: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.LOGOUT_SUCCESS: {
            return {
                ...state,
                data: [],
                selected : {
                    data: null,
                    isLoading: false,
                    error: false,
                },
                isLoading: false,
                error: false
            }
        }
        case Actions.LOGOUT_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        }


        default: {
            return state;
        }
    }
};

export default getExtrasReducer